const FlechaFeb = () => (
    <svg width="54" height="54" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0508 8.13559C11.5279 8.13559 7.05078 12.6128 7.05078 18.1356V55.8644H46.9491C52.4719 55.8644 56.9491 51.3872 56.9491 45.8644V8.13559H17.0508ZM45.0114 14.1242H15.1131V19.0195H44.8798V48.871H49.7611V18.8875H45.0114V14.1242ZM38.5597 21.764L17.4184 42.9656L20.87 46.427L42.0113 25.2255L38.5597 21.764Z" fill="#26D07C" />
    </svg>

)

export default FlechaFeb;